import { defineMessages } from "react-intl";

const SECRET_QUESTION_UPDATE_FORM = "secret-question-update-form";

const secretQuestionUpdateFormMessages = defineMessages({
  success: {
    id: `${SECRET_QUESTION_UPDATE_FORM}.success`,
    defaultMessage: "Your secret question has been successfully updated."
  },
  failure: {
    id: `${SECRET_QUESTION_UPDATE_FORM}.failure`,
    defaultMessage: "Unable to update secret question. Please try again."
  }
});

export default secretQuestionUpdateFormMessages;
